"use client"

import type { UseFormRegister, UseFormSetValue } from "react-hook-form"

import { Input } from "@/components/ui/input"

interface PostalCodeInputProps {
  register: UseFormRegister<any>
  setValue: UseFormSetValue<any>
  name?: string
  required?: boolean
  disabled?: boolean
}

export function PostalCodeInput({
  register,
  setValue,
  name = "zip",
  required = false,
  disabled = false,
}: PostalCodeInputProps) {
  const formatPostalCode = (value: string) => {
    // Remove any non-alphanumeric characters
    const cleaned = value.replace(/[^a-zA-Z0-9]/g, "").toUpperCase()
    const { length } = cleaned

    if (length <= 3) {
      return cleaned
    }
    // Add space after the third character
    return `${cleaned.slice(0, 3)} ${cleaned.slice(3, 6)}`
  }

  return (
    <Input
      {...register(name, {
        required,
        onChange: (event: React.ChangeEvent<HTMLInputElement>) => {
          const formattedValue = formatPostalCode(event.target.value)
          event.target.value = formattedValue
          setValue(name, formattedValue, {
            shouldDirty: true,
            shouldTouch: true,
            shouldValidate: true,
          })
        },
      })}
      required={required}
      placeholder="A1A 1A1"
      maxLength={7}
      disabled={disabled}
    />
  )
}
